import React from "react";
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Slider from "react-slick";

const TeamAreaThree = () => {
  function SampleNextArrow(props) {
    const { className, onClick } = props;
    return <FaAngleRight className={className} onClick={onClick} />;
  }
  function SamplePrevArrow(props) {
    const { className, onClick } = props;
    return <FaAngleLeft className={className} onClick={onClick} />;
  }
  const settings = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          arrows: false,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
        },
      },
    ],
  };
  return (
    <>
      {/*====================== team area start ======================*/}
      <div
        className="team-area bg-relative pd-top-120 pd-bottom-90"
        style={{ backgroundImage: 'url("assets/img/bg/15.png")' }}
      >
        <div className="container pd-top-120">
          <div className="row">
            <div className="col-lg-5">
              <div className="section-title style-white">
                <h6 className="sub-title-sky-blue">精英团队</h6>
                <h2 className="title">未来的顶梁柱</h2>
              </div>
            </div>
          </div>
          <div className="team-slider owl-carousel slider-control-square slider-control-right-top">
            <Slider {...settings}>
              <div className="item px-3">
                <div className="single-team-inner text-center border-radius-5 bg-white">
                  <div className="thumb bg-gray border-radius-5">
                    <img src="assets/img/team/team1.webp" alt="img" />
                  </div>
                  <div className="details">
                    <h5>
                      <p>王宇航</p>
                    </h5>
                    <p>首席技术官 (CTO)</p>
                  </div>
                </div>
              </div>
              <div className="item px-3">
                <div className="single-team-inner text-center border-radius-5 bg-white">
                  <div className="thumb bg-gray border-radius-5">
                    <img src="assets/img/team/team2.webp" alt="img" />
                  </div>
                  <div className="details">
                    <h5>
                      <p>陈泰伦</p>
                    </h5>
                    <p>首席数据官 (CDO)</p>
                  </div>
                </div>
              </div>
              <div className="item px-3">
                <div className="single-team-inner text-center border-radius-5 bg-white">
                  <div className="thumb bg-gray border-radius-5">
                    <img src="assets/img/team/team3.webp" alt="img" />
                  </div>
                  <div className="details">
                    <h5>
                      <p>李梦婷</p>
                    </h5>
                    <p>数据科学家</p>
                  </div>
                </div>
              </div>
              <div className="item px-3">
                <div className="single-team-inner text-center border-radius-5 bg-white">
                  <div className="thumb bg-gray border-radius-5">
                    <img src="assets/img/team/team4.webp" alt="img" />
                  </div>
                  <div className="details">
                    <h5>
                      <p>张明华</p>
                    </h5>
                    <p>机器学习工程师</p>
                  </div>
                </div>
              </div>
            </Slider>
          </div>
        </div>
      </div>

      {/* ====================== team area end ======================*/}
    </>
  );
};

export default TeamAreaThree;
